module Visonum.BulkPingApp.Views.Layout
  ( view
  ) where

import Visonum.BulkPingApp.Prelude

import Data.Maybe (Maybe(..))
import Data.String as Str
import Halogen.HTML.Elements as H

type Props w a =
  { headerPanel :: AppHTML w a
  , mainPanel :: AppHTML w a
  , editPanel :: AppHTML w a
  , detailsPanel :: Maybe (AppHTML w a)
  , loginPanel :: AppHTML w a
  , showLogin :: Boolean
  , error :: Maybe (AppHTML w a)
  }

theme
  :: { background :: String
     , foreground :: String
     , gray1 :: String
     }
theme =
  { background: "#fbfbfb"
  , gray1: "#EDEDED55"
  , foreground: "#000"
  }

view :: forall w a. Props w a -> AppHTML w a
view props =
  let
    elRoot = styleNode H.div
      "Layout"
      [ inline
          { position: "fixed"
          , top: "0"
          , bottom: "0"
          , left: "0"
          , right: "0"
          , backgroundColor: theme.background
          , display: "flex"
          , alignItems: "center"
          , justifyContent: "center"
          }
      ]

    elAppRoot = styleNode H.div
      "AppRoot"
      [ inline
          { backgroundColor: theme.background
          , display: "grid"
          , maxWidth: "1024px"
          , maxHeight: "768px"
          , height: "100%"
          , width: "100%"
          , gridTemplateColumns: "2fr auto"
          , gridTemplateRows: "70px 2fr auto"
          , gridTemplateAreas: Str.joinWith " "
              [ "\"Header    Header      \""
              , "\"MainPanel DetailsPanel\""
              , "\"EditPanel EditPanel   \""
              ]
          , gridRowGap: "10px"
          , position: "relative"
          }
      , if props.showLogin then
          inline
            { gridTemplateColumns: "auto"
            , gridTemplateRows: "70px auto"
            , gridTemplateAreas: Str.joinWith " "
                [ "\"Header   \""
                , "\"LoginPanel\""
                ]
            }
        else
          inline
            { gridTemplateColumns: "2fr auto"
            , gridTemplateRows: "70px 2fr auto"
            , gridTemplateAreas: Str.joinWith " "
                [ "\"Header    Header      \""
                , "\"MainPanel DetailsPanel\""
                , "\"EditPanel EditPanel   \""
                ]
            }
      ]

    elHeader = styleNode H.div
      "Header"
      [ inline
          { gridArea: "Header"
          , backgroundColor: theme.gray1
          , border: "1px solid #d8d8d8"
          }
      ]

    elMainPanel = styleNode H.div
      "MainPanel"
      [ inline
          { margin: "1px"
          , gridArea: "MainPanel"
          , backgroundColor: theme.gray1
          , overflow: "auto"
          , border: "1px solid #d8d8d8"
          }
      ]

    elEditPanel = styleNode H.div
      "EditPanel"
      [ inline
          { margin: "1px"
          , gridArea: "EditPanel"
          , backgroundColor: theme.gray1
          , border: "1px solid #d8d8d8"
          }
      ]

    elDetailsPanel = styleNode H.div
      "DetailsPanel"
      [ inline
          { margin: "1px"
          , gridArea: "DetailsPanel"
          , backgroundColor: theme.gray1
          , border: "1px solid #d8d8d8"
          , marginLeft: "10px"
          , width: "300px"
          , overflow: "auto"
          }
      ]

    elLoginPanel = styleNode H.div
      "LoginPanel"
      [ inline
          { gridArea: "LoginPanel"
          , backgroundColor: theme.gray1
          , border: "1px solid #d8d8d8"
          }
      ]

    elError = styleNode H.div
      "Error"
      [ inline
          { position: "fixed"
          , top: "0"
          , left: "0"
          , right: "0"
          , backgroundColor: "#f95b5b"
          , color: "white"
          , padding: "10px"
          , zIndex: "1000"
          }
      ]
  in
    elRoot []
      [ if props.showLogin then
          elAppRoot
            []
            [ elHeader [] [ props.headerPanel ]
            , elLoginPanel [] [ props.loginPanel ]
            ]
        else
          elAppRoot
            []
            [ elHeader [] [ props.headerPanel ]
            , elMainPanel [] [ props.mainPanel ]
            , elEditPanel [] [ props.editPanel ]
            , case props.detailsPanel of
                Just p -> elDetailsPanel [] [ p ]
                Nothing -> text ""
            ]
      , case props.error of
          Just viewErr -> elError [] [ viewErr ]
          Nothing -> text ""
      ]

